import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topbar clearfix" }
const _hoisted_2 = { class: "topbar-left" }
const _hoisted_3 = { class: "topbar-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "p-link p-d-flex p-ai-center" }
const _hoisted_9 = { class: "p-d-flex p-flex-column" }
const _hoisted_10 = { class: "topbar-item-name" }
const _hoisted_11 = { class: "topbar-item-role" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "profile-image pi pi-user" }, null, -1)
const _hoisted_13 = {
  id: "topbar-profile-menu",
  class: "layout-menu fadeInDown"
}
const _hoisted_14 = { role: "menuitem" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", { class: "p-link topbar-item-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-user" }),
  /*#__PURE__*/_createElementVNode("span", null, "Profilo")
], -1)
const _hoisted_16 = { role: "menuitem" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-sign-out" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_TopBarMessages = _resolveComponent("TopBarMessages")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MessagesWithSidebar = _resolveComponent("MessagesWithSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "p-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goDashboard && _ctx.goDashboard(...args)))
      }, [
        _createVNode(_component_AppLogo)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        id: "menu-button",
        class: "p-link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMenuButtonClick && _ctx.onMenuButtonClick(...args)))
      }, _hoisted_5),
      (_ctx.isTMT)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.messagesRoute,
            class: "p-d-block"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TopBarMessages)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_MessagesWithSidebar, { key: 1 })),
      _createElementVNode("button", {
        id: "topbar-menu-button",
        class: "p-link",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTopbarMenuButtonClick && _ctx.onTopbarMenuButtonClick(...args)))
      }, _hoisted_7),
      _createElementVNode("ul", {
        class: _normalizeClass(_ctx.topbarItemsClass)
      }, [
        (_ctx.profileMode === 'top' || _ctx.horizontal)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(['profile-item', {'active-top-menu': _ctx.activeTopbarItem === 'profile'}]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('topbar-item-click',{originalEvent:$event,item:'profile'})))
            }, [
              _createElementVNode("button", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.userName), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userRole), 1)
                ]),
                _hoisted_12
              ]),
              _createVNode(_Transition, { name: "layout-submenu-container" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("ul", _hoisted_13, [
                    _createElementVNode("li", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: _ctx.profileRoute,
                        style: {"margin":"0","padding":"0","border":"0"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: _ctx.loginRoute,
                        class: "p-link topbar-item-button",
                        onClick: _ctx.logOut
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["to", "onClick"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.activeTopbarItem === 'profile']
                  ])
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}